import React, { Fragment , useState , useEffect} from 'react';
import Moment from 'react-moment';



const Estudiopaciente =({idpacienteEstudio})=>{

      


        return (
   
        <Fragment>
                <div>
                <table className="table table-hover">
             
                  <tbody>
                       <tr />
                      
                       <td >{idpacienteEstudio.nombre}</td>     
                        <td ><Moment format="DD/MM/YYYY">{idpacienteEstudio.fechapedido}</Moment> </td>
                        <td ><Moment format="DD/MM/YYYY">{idpacienteEstudio.fechanetrega}</Moment> </td>
                        {idpacienteEstudio.estado
                        ?
                               
                        <button className="btn btn-link"
                                type="submit" 
                                 
                                ><span className="input-group-text" id="basic-addon">
                                    <i className="fa fa-download"></i>
                                     </span> 
                                 </button>
                        :
                                <br></br>
                        }
                        
                        <button className="btn btn-link" >
                            <span className="input-group-text" id="basic-addon">
                            <i className="fa fa-trash" aria-hidden="true"></i>
                            </span>  </button>
                          
                  
                        </tbody>
                        
                
                        </table>
                </div>
        </Fragment>
        
        )
    
}

export default Estudiopaciente;
